import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, Package, ArrowLeftRight, Anchor } from "lucide-react";

const links = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/prodotti", label: "Prodotti", icon: Package, testid: "nav-products" },
  { to: "/movimenti", label: "Movimenti", icon: ArrowLeftRight, testid: "nav-movements" },
];

export default function Sidebar() {
  return (
    <aside className="sidebar" data-testid="sidebar">
      <div className="flex items-center gap-2 px-2 mb-6">
        <div className="w-9 h-9 rounded bg-orange-600 flex items-center justify-center">
          <Anchor className="w-5 h-5 text-white" />
        </div>
        <div>
          <div className="text-white font-semibold text-sm tracking-tight">
            Reti Molluschi
          </div>
          <div className="text-[10px] text-slate-400 uppercase tracking-[0.18em]">
            Gestione Magazzino
          </div>
        </div>
      </div>

      <div className="eyebrow text-slate-400 px-3 pt-2 pb-1">Menu</div>
      {links.map(({ to, label, icon: Icon, testid }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          className={({ isActive }) => (isActive ? "active" : "")}
          data-testid={testid}
        >
          <Icon className="w-4 h-4" />
          <span>{label}</span>
        </NavLink>
      ))}

      <div className="mt-auto pt-6 text-[11px] text-slate-500 px-3">
        v1.0 · Stabilimento Depurazione
      </div>
    </aside>
  );
}
